/* Leak-Anzeige: liest die .pts-Datei von hlcsg/hlbsp (ein Punkt "x y z" je Zeile). */
import type { Doc, Entity, Vec3 } from '../model/types.ts';
import Core from '../core.ts';
const Leak = (function (Core) {
  'use strict';
  function parse(text: unknown): Vec3[] {
    const pts: Vec3[] = [];
    String(text).split(/\r?\n/).forEach((l) => {
      const m = /^\s*(-?[\d.]+(?:e[-+]?\d+)?)\s+(-?[\d.]+(?:e[-+]?\d+)?)\s+(-?[\d.]+(?:e[-+]?\d+)?)\s*$/i.exec(l);
      if (m) pts.push([parseFloat(m[1]), parseFloat(m[2]), parseFloat(m[3])]);
    });
    return pts;
  }
  function length(pts: Vec3[]): number { let s = 0; for (let i = 1; i < pts.length; i++) s += Core.len(Core.sub(pts[i], pts[i - 1])); return s; }
  /** Nächste Punkt-Entity (mit origin) zu p, gibt {ent, dist} oder null. */
  function nearestEntity(doc: Doc, p: Vec3): { ent: Entity; dist: number } | null {
    let best: { ent: Entity; dist: number } | null = null;
    doc.ents.forEach((e, i) => {
      if (i === 0) return;
      const o = Core.parseVec(e.kv.origin); if (!o) return;
      const d = Core.len(Core.sub(o, p));
      if (!best || d < best.dist) best = { ent: e, dist: d };
    });
    return best;
  }
  /** Liegt der Linienzug nahe an einem Brush (Boxtest)? Liefert Brush-Ids, die das Ende berühren – Hilfe zum Finden der Lücke. */
  function nearBrushes(doc: Doc, p: Vec3, r: number): string[] {
    const res: string[] = [];
    Core.allBrushes(doc).forEach((x) => {
      const bb = Core.bbox(x.b);
      if ([0, 1, 2].every((i) => p[i] >= bb.min[i] - r && p[i] <= bb.max[i] + r)) res.push(x.b.id);
    });
    return res;
  }
  return { parse, length, nearestEntity, nearBrushes };
})(Core);
export default Leak;
